<template>
  <div>
    <v-dialog v-model="isOpen" width="500" persistent>
      <v-card>
        <v-btn icon @click="onClose" class="modal-close-icon">
          <v-icon class="grey--text">mdi-close</v-icon>
        </v-btn>
        <div class="modal-body">
          <v-card-title
            class="headline white modal-title green--text"
            primary-title
          >
            {{ title }}
          </v-card-title>

          <div class="modal-content mx-4">
            <p>
              We are checking on your payment.
              <br />
              We will continously check until
            </p>
            <p class="green--text font-weight-bold">
              {{ summary.formatted_va_expired_at }} WIB
            </p>
            <v-chip
              color="green"
              text-color="white"
              class="font-weight-bold caption"
            >
              <p class="mb-0">Time Remaining :</p>
              <p
                class="ml-1 mb-0 subheader pa-1"
                :id="`expiredDateTime_${summary.id_distributor_balance_order}`"
              >
                <Countdown
                  v-if="summary"
                  :year="summary.yearCountdown"
                  :month="summary.monthCountdown"
                  :date="summary.dateCountdown"
                  :hour="summary.hourCountdown"
                  :minute="summary.minuteCountdown"
                  :second="summary.secondCountdown"
                  :milisecond="summary.milisecondCountdown"
                />
              </p>
            </v-chip>
          </div>
        </div>

        <v-card-actions class="d-flex"> </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Countdown from '@/components/Countdown.vue'

export default {
  name: 'WaitingPaymentTopUpModal',
  components: { Countdown },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    title: {
      type: String,
      default: 'Modal Title'
    },
    summary: {
      type: Object,
      default: () => {}
    }
  },
  computed: {}
}
</script>
<style scoped>
.modal-body {
  padding: 2em;
  text-align: left;
}

.modal-close-icon {
  float: right;
  margin: 1em;
}

.modal-title {
  font-weight: 600;
  font-size: 1.5em !important;
}

.v-card__title {
  padding: 1em;
  margin-bottom: 0;
  margin-top: 1em;
}
</style>
